import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AccountRentalData, AccountRentalDataInitData } from "./AccountRentalData";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import Swal from 'sweetalert2/dist/sweetalert2.js'

interface IMissingMandatoryDataInit {
    rentalParentId: string;
}

@ModuleName("MissingMandatoryData")
export class MissingMandatoryData implements AxInit {

    private _I18nHelper = new I18nHelper();

    private _accountRentalData: AccountRentalData = new AccountRentalData();
    private _rentalParentId: string;


    AxInit(init: IMissingMandatoryDataInit): void {
        this._rentalParentId = init.rentalParentId;
        this.registerSubmitButton();
        this.initRentalDataPartial();
    }

    // initRentalDataPartial
    initRentalDataPartial() {
        this._accountRentalData.AxInit(new AccountRentalDataInitData(this._rentalParentId));
    }

    // registerSubmitForm
    registerSubmitButton() {
        $('#btn_register').click((e) => {
            this.updateAccount(e, $('#update-form'));
        });
    }

    // updateAccount
    updateAccount(event, element) {
        (event.preventDefault ? event.preventDefault() : (event.returnValue = false));
        $('#registerResponseField').html('<div class="fa-3x"><i class="fas fa-spinner fa-spin"></i></div>');

        AxessViewer.onSubmit(event, element, '/Account/MandatoryData', (resp) => {
            if (typeof resp['success'] != 'undefined' && resp['success'] === true) {
                $('#registerResponseField').html('');
                Swal.fire({
                    title: this._I18nHelper.GetTranslation(Translations.Success),
                    icon: 'success',
                    text: resp['message'],
                    confirmButtonText: 'Ok'
                }).then((result) => {
                    $('.m-content > .alert-danger').remove();
                    window.location.href = location.origin;
                });
                return;
            } else {
                if (typeof resp['response'] != 'undefined') {
                    $('#registerResponseField').html(resp['response']);
                } else if (typeof resp['message'] != 'undefined') {
                    $('#registerResponseField').html(resp['message']);
                } else if (typeof resp['szErrorMessage'] != 'undefined') {
                    $('#registerResponseField').html(resp['szErrorMessage']);
                }
            }
        }, { silent: true }, null);
    }
}
